import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { space5 } from '@mediahuis/chameleon-theme-hub';
import { Box, Icon, Flex } from 'CHAMELEON_REACT_HUB';
import convertToSlug from '../../utils/convertToSlug';
import { useComponents, useIcons } from '../../utils/multiBrandedTheme';
import { useThemeContext } from '../ThemeContext';

const List = styled(Box)`
  @media only screen and (min-width: ${({ theme }) =>
      theme.gridBreakpointMedium}) {
    display: grid;
    grid-gap: 0 ${space5};
    grid-auto-flow: column;
    grid-template-rows: repeat(6, min-content);
  }
`;

const Subnav = ({ headings, pathName }) => {
  const { LinkText } = useComponents();
  const { ArrowDown } = useIcons();
  const [theme] = useThemeContext();

  return headings && headings.length > 0 ? (
    <Box as="nav" mb={10}>
      <List as="ul">
        {headings.map(heading => {
          return (
            <Box key={convertToSlug(heading.value)} as="li" mb={4}>
              <LinkText
                branded={true}
                href={`${pathName}?brand=${theme}#h-${convertToSlug(
                  heading.value
                )}`}
              >
                <Flex alignItems="center">
                  <Icon as={ArrowDown} size="small" mr={3} />
                  {heading.value}
                </Flex>
              </LinkText>
            </Box>
          );
        })}
      </List>
    </Box>
  ) : null;
};

Subnav.propTypes = {
  headings: PropTypes.arrayOf(
    PropTypes.shape({
      depth: PropTypes.number,
      value: PropTypes.string,
    })
  ).isRequired,
  pathName: PropTypes.string.isRequired,
};

export default Subnav;
